import TheWorkingMan from '../Assets/Images/TheWorkingMan.png';
import React from 'react';
import { useText } from '../Content/SiteContentContext';
import PageBlocks from '../Content/PageBlocks';
import SiteAssetImage from '../Content/SiteAssetImage';

function WorkInProgrog(): JSX.Element {
  return (
    <div>
      <header className="App-header">
        {/* Entry animation: replaceable from the admin center (Media tab);
            falls back to the bundled image until a GIF has been uploaded. */}
        <SiteAssetImage
          assetKey="home.entryAnimation"
          fallbackSrc={TheWorkingMan}
          className="App-logo"
          alt="TheWorkingMan"
        />
        <p>{useText('home.wip.text')}</p>
        <a
          className="App-link"
          href="https://obesquito.itch.io/mark-of-the-knights"
          target="_blank"
          rel="noopener noreferrer"
        >
          {useText('home.wip.linkText')}
        </a>
      </header>

      <section className="About">
        <h1>{useText('home.about.title')}</h1>
        <p>{useText('home.about.body')}</p>
        {/* Admin-managed paragraphs (admin center > Page sections > Home). */}
        <PageBlocks page="Home" />
      </section>
    </div>
  );
}

export default WorkInProgrog;
